module.exports = __webpack_public_path__ + "img/download_pattern_right.5fb8b1db.png";